import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowRight, ArrowLeft } from 'lucide-react';
export const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  return <div className="min-h-screen flex" data-id="element-1031">
      {/* Left: Image */}
      <div className="hidden lg:block lg:w-1/2 relative" data-id="element-1032">
        <img src="https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&q=80&w=1000" alt="Luxury Real Estate" className="w-full h-full object-cover" data-id="element-1033" />
        <div className="absolute inset-0 bg-primary-900/40" data-id="element-1034" />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-900 to-transparent" data-id="element-1035" />

        <div className="absolute bottom-12 left-12 right-12 text-white" data-id="element-1036">
          <Link to="/" className="flex items-center gap-2 mb-8" data-id="element-1037">
            <div className="w-10 h-10 rounded bg-secondary flex items-center justify-center font-serif font-bold text-2xl text-primary-900" data-id="element-1038">
              A
            </div>
            <span className="font-serif font-bold text-3xl tracking-tight" data-id="element-1039">
              AMU
            </span>
          </Link>
          <h2 className="text-4xl font-serif font-bold mb-4" data-id="element-1040">
            Secure Recovery
          </h2>
          <p className="text-lg text-white/80 max-w-md" data-id="element-1041">
            Regain access to your verified real estate portfolio securely.
          </p>
        </div>
      </div>

      {/* Right: Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-white" data-id="element-1042">
        <div className="w-full max-w-md" data-id="element-1043">
          {/* Mobile Logo */}
          <Link to="/" className="flex lg:hidden items-center gap-2 mb-12 justify-center" data-id="element-1044">
            <div className="w-10 h-10 rounded bg-primary-900 flex items-center justify-center font-serif font-bold text-2xl text-secondary" data-id="element-1045">
              A
            </div>
            <span className="font-serif font-bold text-3xl tracking-tight text-primary-900" data-id="element-1046">
              AMU
            </span>
          </Link>

          <Link to="/login" className="inline-flex items-center gap-2 text-sm font-bold text-text-light hover:text-primary-900 mb-8 transition-colors" data-id="element-1047">
            <ArrowLeft size={16} data-id="element-1048" /> Back to Login
          </Link>

          <div className="mb-10" data-id="element-1049">
            <h1 className="text-3xl font-serif font-bold text-primary-900 mb-2" data-id="element-1050">
              Reset Password
            </h1>
            <p className="text-text-light" data-id="element-1051">
              Enter your email address and we'll send you a code to reset your
              password.
            </p>
          </div>

          <form onSubmit={e => {
          e.preventDefault();
          window.location.href = '/verify-otp';
        }} className="space-y-6" data-id="element-1052">
            <div data-id="element-1053">
              <label className="block text-sm font-bold text-text mb-2" data-id="element-1054">
                Email Address
              </label>
              <div className="relative" data-id="element-1055">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-neutral-dark" size={20} data-id="element-1056" />
                <input type="email" placeholder="name@example.com" className="w-full pl-12 pr-4 py-3.5 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none transition-all" required data-id="element-1057" />
              </div>
            </div>

            <button type="submit" className="w-full bg-primary-900 hover:bg-primary-800 text-white py-4 rounded-xl font-bold transition-colors flex items-center justify-center gap-2 shadow-lg" data-id="element-1058">
              Send Reset Code <ArrowRight size={18} data-id="element-1059" />
            </button>
          </form>
        </div>
      </div>
    </div>;
};